<template>
  <div class="decrypt-img">
    <el-image
      class="decrypt-img"
      v-if="decryptBlob"
      :src="decryptBlob"
      :preview-src-list="previewSrcList"
      fit="contain"
      @load="onImgLoad"
      v-bind="$attrs"
    ></el-image>
  </div>
</template>

<script>
import videoApi from "@/api/videoManagement";

export default {
  name: "LongText",
  props: ["src", "origin", "iPreviewSrcList"],
  emit: ["load"],
  data() {
    return {
      decryptBlob: null,
    };
  },
  computed: {
    previewSrcList() {
      if (this.iPreviewSrcList) return this.iPreviewSrcList;
      if (this.decryptBlob) return [this.decryptBlob];
      return [];
    },
  },
  watch: {
    src: {
      async handler(val) {
        const url = val;
        this.decryptBlob = !this.origin
          ? await videoApi.imgDecyptApi(url)
          : this.src;
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    onImgLoad(e) {
      this.$emit("load", {
        event: e,
        blob: this.decryptBlob,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.decrypt-img {
  width: 100%;
  height: 100%;
}
</style>
